import {CHANGE_PLACE} from './mapTypes'
export const changePlace = (place)=>{
    return{
        type:CHANGE_PLACE,
        payload:place
    }
}
